import React from 'react';
import TopNav from '../shared/TopNav';
import './Header.scss';

const Header = () => {
  return (
    <header className="Header">
      <TopNav />
    </header>
  );
};
export default Header;
